
export const formatMoney = currencyCode => amount =>
  !Number.isNaN(amount) && amount !== null && amount.toLocaleString('en-US', { style: 'currency', currency: currencyCode })

